// extracted by mini-css-extract-plugin
export default {"placeholder":"dropdown_placeholder__15YPb","menu":"dropdown_menu__porP4","control":"dropdown_control__gc8Uk","lg":"dropdown_lg__+I8kD","right":"dropdown_right__lx8v-"};